import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationTickets from "../../../components/organization/reports/daily/OrganizationTickets";
import {
  TICKET_SUMMARY_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationTickets = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={TICKET_SUMMARY_COLUMN_DEFINITIONS}
    descriptionKey="Tickets"
    title={`${reportIndex}. Organization Tickets`}
  >
    {({ data, renderConfig }) => (
      <OrganizationTickets reportIndex={reportIndex} data={data[0]} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationTickets;
